import Vue from 'vue';
import axios from 'axios'; 
 
export default {
  name: 'GisMapSettings',
  data: function () {
    return {
      maps: [],
      options: { pageSize: 10, total: 0, page: 1 },
    }
  },
  created() {
    this.getMaps();
  },
  methods: {
    getMaps() {
      axios.post('/GIS/GetMaps')
        .then(response => {
          if (response.data.data.status == 0) {
            this.maps = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    addMap() {
      this.$router.push('/mapSettings/0');
    },
    editMap(id) {
      var route = '/mapSettings/' + id;
      this.$router.push(route);
    },
    deleteMap(id) {
      axios.post('/GIS/DeleteMap', { Value: id })
        .then(response => {
          if (response.data.data.status == 0) {
            this.getMaps();
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    onPagination(args) {
      this.options.page = args.page;
      this.options.pageSize = args.size;
      this.getMaps();
    },
    close() {
      this.$router.go(-1);
    },
  },

}
